module.exports = __webpack_public_path__ + "img/personal_invite_icon_wechat.1775439203884.png";